import { ComponentRegistry } from '../core/component-registry';
import { ColumnInUseByComponent } from './column-inuseby/column-inuseby.component';
import { ColumnRealizationComponent } from './column-realization/column-realization.component';
import { ColumnRepeatComponent } from './column-repeat/column-repeat.component';
import { CopyShiftComponent } from './copy-shift/copy-shift.component';
import { CopyTaskComponent } from './copy-task/copy-task.component';
import { BatchPlanmacroComponent } from './batch-planmacro/batch-planmacro.component';
import { DataViewComponent } from './data-view/data-view.component';
import { DetailComponent } from './detail/detail.component';
import { FieldsetAssigneeComponent } from './fieldset-assignee/fieldset-assignee.component';
import { FieldsetInUseByComponent } from './fieldset-inuseby/fieldset-inuseby.component';
import { FieldsetLocationComponent } from './fieldset-location/fieldset-location.component';
import { FieldsetMultiTypeComponent } from './fieldset-multi-type/fieldset-multi-type.component';
import { FieldsetParentChildComponent } from './fieldset-parent-child/fieldset-parent-child.component';
import { FieldsetRepeatComponent } from './fieldset-repeat/fieldset-repeat.component';
import { FormComponent } from './form/form.component';
import { ListComponent } from './list/list.component';
import { RelationComponent } from './relation/relation.component';
import { RepeatSplitFormComponent } from './repeat-split-form/repeat-split-form.component';
import { ColumnColorComponent } from './column-color/column-color.component';
import { ColumnDatetimeDeviationComponent } from './column-datetime-deviation/column-datetime-deviation.component';
import { ColumnDurationDeviationComponent } from './column-duration-deviation/column-duration-deviation.component';
import { ColumnRequirementComponent } from './column-requirement/column-requirement.component';
import { FieldsetColorComponent } from './fieldset-color/fieldset-color.component';
import { ColumnContractHoursComponent } from './column-contract-hours/column-contract-hours.component';
var COLUMN_COMPONENTS = [
    ColumnInUseByComponent,
    ColumnRealizationComponent,
    ColumnRepeatComponent,
    ColumnColorComponent,
    ColumnDatetimeDeviationComponent,
    ColumnDurationDeviationComponent,
    ColumnRequirementComponent,
    ColumnContractHoursComponent
];
var FIELDSET_COMPONENTS = [
    FieldsetAssigneeComponent,
    FieldsetInUseByComponent,
    FieldsetLocationComponent,
    FieldsetMultiTypeComponent,
    FieldsetParentChildComponent,
    FieldsetRepeatComponent,
    FieldsetColorComponent
];
var DomainModule = /** @class */ (function () {
    /**
     * Creates an instance of DomainModule.
     */
    function DomainModule() {
        ComponentRegistry.register('detail', 'DetailComponent', DetailComponent);
        ComponentRegistry.register('list', 'ListComponent', ListComponent);
        ComponentRegistry.register('overlay', 'RepeatSplitFormComponent', RepeatSplitFormComponent);
        ComponentRegistry.register('overlay', 'FormComponent', FormComponent);
        ComponentRegistry.register('overlay', 'CopyTaskComponent', CopyTaskComponent);
        ComponentRegistry.register('overlay', 'BatchPlanmacroComponent', BatchPlanmacroComponent);
        ComponentRegistry.register('overlay', 'CopyShiftComponent', CopyShiftComponent);
        ComponentRegistry.register('relation', 'RelationComponent', RelationComponent);
        ComponentRegistry.register('route', 'DataViewComponent', DataViewComponent);
        ComponentRegistry.register('route', 'DetailComponent', DetailComponent);
        COLUMN_COMPONENTS.forEach(function (columnClass) {
            columnClass.register();
        });
        FIELDSET_COMPONENTS.forEach(function (fieldSetClass) {
            fieldSetClass.register();
        });
    }
    return DomainModule;
}());
export { DomainModule };
